import { useEffect, useState } from 'react';
import { BREAKPOINTS } from '@theme/scalingTokens';

const MOBILE_QUERY = `(max-width: ${BREAKPOINTS.tablet - 1}px)`;

function readMatch(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(MOBILE_QUERY).matches;
}

/**
 * Returns `true` when the viewport is below `BREAKPOINTS.tablet`
 * (mobile + small-tablet range). Subscribes to `matchMedia` change events so
 * components re-render on viewport resize. SSR-safe.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => readMatch());

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', handler);
    return () => {
      mql.removeEventListener('change', handler);
    };
  }, []);

  return isMobile;
}
